import React from "react";
import { Link } from "react-router-dom";

const Footer: React.FC = () => {
  return (
    <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
      <p className="mb-0">2025 © CMS.</p>
      <p>
        Designed &amp; Developed By{" "}
        <Link
          to="#"
          className="text-primary"
          onClick={(e: any) => e.preventDefault()}
        >
          ZYVO
        </Link>
      </p>
    </div>
  );
};

export default Footer;
